import { observer } from 'mobx-react-lite';
import React from 'react';
import { bookingSummaryState } from '#/components/BookingSummaryPanel/BookingSummaryContext';
import config from '@jucy-nakuru/config/clientConfig';
import { getDocumentScrollbarSize } from '@jucy-ui/common';
import BorderColorSharpIcon from '@mui/icons-material/BorderColorSharp';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { useTheme } from '@mui/material/styles';

const TestEnvRibbon: React.FC = observer(function TestEnvRibbonComponent() {
    const isTest = config.app.env === 'test';
    const theme = useTheme();

    if (!isTest) {
        return null;
    }
    const scrollbarSize = getDocumentScrollbarSize();

    return (
        <>
            {isTest && (
                <Alert
                    severity="success"
                    sx={{
                        marginRight: bookingSummaryState.open ? `-${scrollbarSize}px` : 0,
                        paddingRight: bookingSummaryState.open ? `${scrollbarSize}px` : 0,
                        borderRadius: 0,
                        justifyContent: 'center',
                        alignItems: 'center',
                        background: theme.palette.secondary.main,
                        color: 'white',
                        height: `${theme.settings?.appBar.testBannerHeight}px`,
                    }}
                    icon={<BorderColorSharpIcon sx={{ fill: 'white', marginBottom: 1 }} />}
                >
                    <AlertTitle sx={{ fontSize: '0.75rem', marginBottom: 0 }}>
                        <strong>You are currently viewing the test environment</strong>
                    </AlertTitle>
                </Alert>
            )}
        </>
    );
});

export default TestEnvRibbon;
